import { isUserAdmin, type MyPermissions } from '@/app/permissions/permissionHelpers'

export const CONNECTION_MAIL_PATH = '/administration/mail'

export function showConnectionMail(perms: MyPermissions | undefined): boolean {
  return isUserAdmin(perms)
}
